<script setup lang="ts"></script>

<template>
  <footer class="admin-footer">
    <p class="admin-footer__text">
      <span>© 2026 芯位人工智能学院 版权所有</span>
      <span class="admin-footer__sep">|</span>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">琼ICP备2021008302号-19</a>
      <span class="admin-footer__sep">|</span>
      <img src="/images/110.png" class="footer-beian-icon" alt="" />
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=46020002000470" target="_blank" rel="noreferrer">
        琼公网安备46020002000470号
      </a>
      <span class="admin-footer__sep">|</span>
      <span>技术支持：芯位科技</span>
    </p>
  </footer>
</template>

<style lang="scss" scoped>
  .admin-footer {
    flex-shrink: 0;
    padding: 12px 4px 0;
  }

  .admin-footer__text {
    margin: 0;
    text-align: center;
    font-size: 12px;
    line-height: 1.6;
    color: #94a3b8;
  }

  .admin-footer__sep {
    margin: 0 6px;
    color: #cbd5e1;
  }

  .admin-footer a {
    color: #94a3b8;
    text-decoration: none;
    transition: color 0.15s ease;
  }

  .admin-footer a:hover {
    color: #0085db;
  }
</style>
